export const parentObjectTypes = [
  'parent_necropolis',
  'parent_fortification',
  'parent_hillfort',
  'parent_settlement',
  'parent_polyculture',
  'parent_oppidum',
  'parent_viereckschanze',
  'parent_deposit_site',
] as const;

export type ParentObjectType = typeof parentObjectTypes[number];

export const parentObjectTypeLabels: Record<ParentObjectType, string> = {
  parent_necropolis: 'Necropolis',
  parent_fortification: 'Fortified site',
  parent_hillfort: 'Hillfort',
  parent_settlement: 'Settlement',
  parent_polyculture: 'Polyculture site',
  parent_oppidum: 'Oppidum',
  parent_viereckschanze: 'Viereckschanze site',
  parent_deposit_site: 'Deposit site',
};

export const parentObjectTypeColors: Record<ParentObjectType, string> = {
  parent_necropolis: '#7b1fa2',
  parent_fortification: '#c62828',
  parent_hillfort: '#2e7d32',
  parent_settlement: '#ef6c00',
  parent_polyculture: '#00838f',
  parent_oppidum: '#1565c0',
  parent_viereckschanze: '#6d4c41',
  parent_deposit_site: '#ad1457',
};

const DEFAULT_PARENT_COLOR = '#546e7a';

export const PARENT_TYPE_PREFIX = 'parent_';

export function isParentType(type?: string | null): boolean {
  return !!type && type.startsWith(PARENT_TYPE_PREFIX);
}

export function getParentTypeColor(type?: string | null): string {
  if (!type) return DEFAULT_PARENT_COLOR;
  return (
    (parentObjectTypeColors as Record<string, string>)[type] ??
    DEFAULT_PARENT_COLOR
  );
}

export function getParentTypeLabel(type?: string | null): string {
  if (!type) return '';
  return (
    (parentObjectTypeLabels as Record<string, string>)[type] ??
    type.replace(PARENT_TYPE_PREFIX, '').replace(/_/g, ' ')
  );
}
